import lower_my_payment from "./lower_my_payment";
import top_up_refinance from './top_up_refinance';
import * as lgpdAuthorizedUser from './lgpdAuthorizedUser';
import * as requestTypes from './lgpd/requests';
import confirmation from './lgpd/confirmation';
import shared from './lgpd/shared';
import index from './lgpd/index';
import download from './lgpd/download';
import loan_offers from './loan_offers';
import loan_applications from './loan_applications';
import direct_debit_opt_in from './direct_debit_opt_in';
import overdraft_opt_in from './overdraft_opt_in';
import account_home from './account_home';
import loan_status from './loan_status';
import reg_ebs from './reg_ebs';
import simplic_express_iframe from './simplic_express_iframe';
import preapprovals from './preapprovals';

export default {
  lower_my_payment,
  top_up_refinance,
  lgpd: {
    requestTypes,
    shared,
    confirmation,
    index,
    download,
  },
  lgpdAuthorizedUser,
  loan_offers,
  loan_applications,
  direct_debit_opt_in,
  overdraft_opt_in,
  account_home,
  loan_status,
  reg_ebs,
  simplic_express_iframe,
  preapprovals,
};
